export default "__VITE_ASSET__DBTvuqCT__"